import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'app-calibrant-load',
    template: `<img [width]="width" [height]="height" src="../../../../assets/img/calibrantSpinner.gif" style="margin: 5rem;">`,
    standalone: false
})
export class CalibrantLoadComponent implements OnInit {
  width: number;
  height: number;

  @Input() small: boolean;

  constructor() {}

  ngOnInit() {
    if (this.small) {
      this.height = 100;
      this.width = 100;
    } else {
      this.width = 251;
      this.height = 252;
    }
  }
}
